import { Link } from 'react-router-dom';

export default function About() {
  const heroImage = 'https://readdy.ai/api/search-image?query=diverse%20group%20of%20happy%20volunteers%20in%20matching%20t-shirts%20at%20outdoor%20community%20event%2C%20warm%20golden%20hour%20lighting%2C%20documentary%20style%20photography%2C%20authentic%20joyful%20expressions%2C%20teamwork%20and%20unity%2C%20warm%20earth%20tones%20background%2C%20no%20blue%20or%20purple&width=1400&height=800&seq=ab-hero-001&orientation=landscape';
  const teamImage1 = 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20confident%20woman%20CEO%20leader%20in%20her%2050s%2C%20warm%20natural%20lighting%2C%20clean%20neutral%20background%2C%20friendly%20approachable%20expression%2C%20documentary%20portrait%20style%2C%20warm%20earth%20tones&width=400&height=500&seq=team-001&orientation=portrait';
  const teamImage2 = 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20kind%20male%20humanitarian%20worker%20in%20his%2040s%20with%20warm%20smile%2C%20natural%20lighting%2C%20neutral%20background%2C%20approachable%20expression%2C%20documentary%20portrait%20style%2C%20warm%20earth%20tones&width=400&height=500&seq=team-002&orientation=portrait';
  const teamImage3 = 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20young%20female%20education%20coordinator%20in%20her%2030s%20with%20bright%20smile%2C%20natural%20lighting%2C%20neutral%20background%2C%20energetic%20expression%2C%20documentary%20portrait%20style%2C%20warm%20earth%20tones&width=400&height=500&seq=team-003&orientation=portrait';
  const teamImage4 = 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20compassionate%20male%20veterinarian%20in%20his%2030s%20with%20warm%20smile%2C%20natural%20lighting%2C%20neutral%20background%2C%20caring%20expression%2C%20documentary%20portrait%20style%2C%20warm%20earth%20tones&width=400&height=500&seq=team-004&orientation=portrait';

  const values = [
    {
      title: 'Compassion First',
      description: 'Every decision we make is guided by empathy and the genuine desire to help those in need.',
      icon: 'ri-heart-line',
    },
    {
      title: 'Transparency',
      description: 'We believe donors deserve to know exactly how their contributions create real impact.',
      icon: 'ri-eye-line',
    },
    {
      title: 'Community Driven',
      description: 'Local communities lead our programs. We listen, adapt, and empower from within.',
      icon: 'ri-community-line',
    },
    {
      title: 'Sustainable Impact',
      description: 'We build lasting solutions, not temporary fixes. Our programs create self-sustaining change.',
      icon: 'ri-seedling-line',
    },
  ];

  const team = [
    { name: 'Amara Johnson', role: 'Founder & CEO', image: teamImage1 },
    { name: 'Marcus Webb', role: 'Director of Operations', image: teamImage2 },
    { name: 'Leila Torres', role: 'Education Program Lead', image: teamImage3 },
    { name: 'James Nakamura', role: 'Animal Rescue Coordinator', image: teamImage4 },
  ];

  return (
    <div className="overflow-x-hidden">
      {/* Hero */}
      <section className="relative w-full min-h-[60vh] md:min-h-[70vh] flex items-end overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${heroImage})` }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
        <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 pb-16 md:pb-24">
          <span className="inline-block bg-white/20 backdrop-blur-sm text-white px-5 py-2 rounded-full text-sm font-medium mb-6">
            About Us
          </span>
          <h1 className="text-white text-4xl md:text-6xl lg:text-7xl font-bold max-w-3xl leading-tight">
            A movement built on
            <span className="font-serif italic font-light"> compassion</span>
          </h1>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="w-full py-20 md:py-28 bg-white">
        <div className="w-full px-6 md:px-10 lg:px-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
            <div>
              <span className="text-brand-600 text-sm font-semibold tracking-wider uppercase mb-4 block">
                Our Mission
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
                To create a world where no one goes hungry, everyone has access to education, and every life is valued.
              </h2>
              <p className="text-gray-600 text-base md:text-lg leading-relaxed">
                We work directly with communities to deliver emergency aid and build long-term resilience.
                From disaster zones to underserved neighborhoods, our teams are there providing food,
                shelter, education, and hope. Every meal served, every school built, every animal
                rescued is a step toward a more just world.
              </p>
            </div>
            <div>
              <span className="text-brand-600 text-sm font-semibold tracking-wider uppercase mb-4 block">
                Our Vision
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
                A global community where compassion drives action and every person thrives.
              </h2>
              <p className="text-gray-600 text-base md:text-lg leading-relaxed">
                By 2030, we aim to reach 10 million people with life-sustaining support. We envision
                a network of empowered local leaders, sustainable food systems, quality education for
                all children, and zero animals suffering from neglect. This is not just a dream —
                it is a plan we are executing every single day.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="w-full py-20 md:py-28 bg-warm-50">
        <div className="w-full px-6 md:px-10 lg:px-16">
          <div className="text-center mb-16">
            <span className="text-brand-600 text-sm font-semibold tracking-wider uppercase mb-3 block">
              What Drives Us
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900">
              Our core values
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value) => (
              <div key={value.title} className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-shadow duration-300">
                <div className="w-14 h-14 rounded-xl bg-brand-50 flex items-center justify-center mb-5">
                  <i className={`${value.icon} text-brand-600 text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{value.title}</h3>
                <p className="text-gray-500 leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="w-full py-20 md:py-28 bg-white">
        <div className="w-full px-6 md:px-10 lg:px-16">
          <div className="text-center mb-16">
            <span className="text-brand-600 text-sm font-semibold tracking-wider uppercase mb-3 block">
              The People
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900">
              Meet our leadership
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {team.map((member) => (
              <div key={member.name} className="group">
                <div className="rounded-2xl overflow-hidden mb-5 aspect-[4/5]">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <h3 className="text-lg font-bold text-gray-900">{member.name}</h3>
                <p className="text-gray-500 text-sm">{member.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="w-full py-20 md:py-28 bg-gray-900">
        <div className="w-full px-6 md:px-10 lg:px-16 text-center">
          <h2 className="text-white text-3xl md:text-5xl font-bold mb-6">
            Be part of our story
          </h2>
          <p className="text-white/60 text-lg max-w-2xl mx-auto mb-10">
            Whether you donate, volunteer, or simply share our mission, you help us reach more lives every day.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/donate"
              className="inline-flex items-center gap-2 bg-brand-500 text-white px-8 py-4 rounded-full font-semibold hover:bg-brand-600 transition-colors"
            >
              Make a Donation
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/volunteer"
              className="inline-flex items-center gap-2 bg-white/10 text-white px-8 py-4 rounded-full font-semibold hover:bg-white/20 transition-colors"
            >
              Become a Volunteer
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}